import { ACCESS_STATES, RECORD_TYPES } from "../api/recordResolverApi";
import { PUBLIC_ACCESS_OPTIONS } from "../../../utils/accessMapConstants";
import { PUBLIC_ACCESS_OPTION_ICONS } from "../../../shared/constants/fieldIcons";

function isPublicAccess(accessState) {
  return (
    accessState === ACCESS_STATES.PUBLIC_VIEW ||
    accessState === ACCESS_STATES.PUBLIC_EDIT
  );
}

export function inferRecordType(recordId, resolvedType) {
  if (resolvedType) return resolvedType;
  if (recordId?.startsWith("PR_")) return RECORD_TYPES.PROJECT;
  if (recordId?.startsWith("CD_")) return RECORD_TYPES.COLLECTION;
  if (recordId?.startsWith("EN_")) return RECORD_TYPES.ENTITY;
  return RECORD_TYPES.UNKNOWN;
}

export function buildPublicRoute(recordId, recordType) {
  if (recordType === RECORD_TYPES.COLLECTION) {
    return `/public/map-editor/${recordId}`;
  }
  if (recordType === RECORD_TYPES.PROJECT) {
    return `/public/project/${recordId}`;
  }
  return null;
}

export function classifyShareResolution(response, recordId) {
  const accessState = response?.data?.accessState;
  const resolvedType = response?.data?.recordType;
  const recordType = inferRecordType(recordId, resolvedType);
  const status = response?.status;

  if (status === 404 || accessState === ACCESS_STATES.RECORD_NOT_FOUND) {
    return { kind: "not_found", recordType };
  }

  // Backend share resolver returns RESTRICTED for private items.
  // Spring Security may also reject anonymous callers with 401/403.
  if (
    status === 401 ||
    status === 403 ||
    accessState === ACCESS_STATES.RESTRICTED
  ) {
    return { kind: "restricted", recordType };
  }

  if (response?.ok && isPublicAccess(accessState)) {
    if (recordType === RECORD_TYPES.ENTITY) {
      return { kind: "unsupported", recordType, accessState };
    }
    return { kind: "public", recordType, accessState };
  }

  if (!response?.ok && !accessState) {
    return { kind: "restricted", recordType };
  }

  return { kind: "error", recordType };
}

/** Protected sessions are always editable; public sessions only when share is PUBLIC_EDIT. */
export function isPublicMapEditorReadOnly(pageMode, publicAccessState) {
  if (pageMode !== "public") return false;
  return publicAccessState !== ACCESS_STATES.PUBLIC_EDIT;
}

export function getPublicMapEditorHeaderTitle(pageMode, publicAccessState) {
  if (pageMode !== "public") return "Map Editor";
  return publicAccessState === ACCESS_STATES.PUBLIC_EDIT
    ? "Public Map Editor"
    : "Public Map Viewer";
}

export function getPublicAccessChipLabel(accessState) {
  if (accessState === ACCESS_STATES.PUBLIC_EDIT) {
    return "Public edit";
  }
  return "Public view";
}

export function getPublicAccessChipIcon(accessState) {
  if (accessState === ACCESS_STATES.PUBLIC_EDIT) {
    return PUBLIC_ACCESS_OPTION_ICONS[PUBLIC_ACCESS_OPTIONS.EDIT];
  }
  return PUBLIC_ACCESS_OPTION_ICONS[PUBLIC_ACCESS_OPTIONS.VIEW];
}
